import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

export function UserAvatar({
  picture,
  large = false,
}: {
  picture: string;
  large?: boolean;
}) {
  return (
    <>
      {large ? (
        <Avatar className="size-[200px]">
          <AvatarImage
            src={picture ?? "/images/anonymous-icon.jpg"}
            alt={picture ?? "Profile Image"}
          />
          <AvatarFallback>N/A</AvatarFallback>
        </Avatar>
      ) : (
        <Avatar className="h-8 w-8 rounded-lg">
          <AvatarImage
            src={picture ?? "/images/anonymous-icon.jpg"}
            alt={picture ?? "Profile Image"}
          />
          <AvatarFallback className="rounded-lg">N/A</AvatarFallback>
        </Avatar>
      )}
    </>
  );
}
